<div class="timepicker-free-text" [class.has-changes]="hasChanges">
  <input
      [attr.type]="inputType"
      [(ngModel)]="dateView"
      [attr.data-qa-id]="dataQaId + '-TimeInput'"
      (blur)="onBlur()"
      (change)="onChange()"
      (click)="onClick()"
      #inputDate
      inputNumber
      placeholder=""
      maxlength="5"
      />
</div>
